export enum AreaOfInterest {
  NFT = "nft",
  DeFi = "deFi",
  Infrastructure = "infrastructure",
  GameFi = "gameFi",
  Social = "social",
  Analytics = "analytics",
  Other = "other",
}

export enum DomainOfExpertise {
  Marketing = "marketing",
  Tokenomics = "tokenomcis",
  Community = "community",
  GrowthHacking = "growthHacking",
  Dev = "dev",
  UI_UX = "ui/ux",
  Legal = "legal",
  Other = "other",
}

export enum WhitelistingStatus {
  Approved = "approved",
  Denied = "denied",
  Pending = "pending",
}

export enum WhitelistingAction {
  Add,
  Remove,
}

export enum MonkeAdminPermissions {
  CreateClub = "createClub",
  AddWhitelisting = "whitelistMembers",
}

export enum MonkeAdminStatus {
  Accepted = "accepted",
  Rejected = "rejected",
}

export enum WhiteListingLastAction {
  Bot = "Bot",
  Form = "Form",
  Admin = "Admin",
}
